/**
 * Форма слова по числу: plural(3, 'шкаф', 'шкафа', 'шкафов') → «шкафа».
 */
export function plural(n, one, few, many) {
  const m10 = n % 10,
    m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}
